import { useEffect } from "react";

import { getCanvasSize } from "../utils/canvasSize";
import { getCoverScale } from "../utils/getCoverScale";
import { drawCanvas } from "../utils/drawCanvas";

export function useResizeCanvasOnGridChange({
  img,
  grid,
  canvasRef,
  setScale,
  setOffset,
}) {
  useEffect(() => {
    if (!img) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const size = getCanvasSize(grid);

    canvas.width = size.width;
    canvas.height = size.height;

    const nextScale = getCoverScale(img, canvas);

    const nextOffset = {
      x: (canvas.width - img.width * nextScale) / 2,
      y: (canvas.height - img.height * nextScale) / 2,
    };

    setScale(nextScale);
    setOffset(nextOffset);

    drawCanvas({
      canvas,
      image: img,
      scale: nextScale,
      offset: nextOffset,
      grid,
    });
  }, [img, grid, canvasRef, setScale, setOffset]);
}